import React, { useContext } from 'react';
import { UserContext } from '../UserContext';

const overlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  width: '100%', height: '100%',
  background: 'rgba(15, 31, 43, 0.6)',
  backdropFilter: 'blur(4px)',
  zIndex: 9999,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '16px',
};

const spinnerStyle = {
  width: '56px',
  height: '56px',
  border: '4px solid rgba(48, 221, 251, 0.2)',
  borderTopColor: '#30ddfb',
  borderRadius: '50%',
  animation: 'cgt-spin 0.75s linear infinite',
};

const labelStyle = {
  fontFamily: 'Poppins, sans-serif',
  fontSize: '0.8rem',
  fontWeight: 600,
  color: '#30ddfb',
  letterSpacing: '3px',
  textTransform: 'uppercase',
};

// Inject keyframe once
if (!document.getElementById('cgt-spin-style')) {
  const s = document.createElement('style');
  s.id = 'cgt-spin-style';
  s.textContent = '@keyframes cgt-spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(s);
}

function Loader() {
  const { loading } = useContext(UserContext);
  if (!loading) return null;

  return (
    <div style={overlayStyle}>
      <div style={spinnerStyle} />
      <span style={labelStyle}>Loading...</span>
    </div>
  );
}

export default Loader;